export const Language_Options = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
];
